export const COLOR_PRIMARY = "#3e5988";
export const SECTION_MARGIN_BOTTOM = "10rem";
